import React from 'react';
import PropTypes from 'prop-types';
import {Form} from 'formik';
import classnames from 'classnames';
import FieldInput from 'common/components/FieldInput';
import FieldTextarea from 'common/components/FieldTextarea';
import closeButton from '../../../../common/assets/close_button.svg';
import styles from './styles.module.scss';

const ContactLoginView = ({
                            values,
                            onSubmitClick,
                            modalContactSlide,
                            slideModalContact
                          }) => {
  const handleOverlayClick = () => {
    if (modalContactSlide) {
      slideModalContact();
    }
  }

  return (
    <div
      className={modalContactSlide ? styles.overlayShow : styles.overlayHide}
      onClick={handleOverlayClick}
    >
      <div
        className={modalContactSlide ? styles.desktopModalContactShow : styles.desktopModalContactHide}
        onClick={e => e.stopPropagation()}
      >
        <div className={styles.inner}>
          <img
            src={closeButton}
            alt="close-button"
            onClick={slideModalContact}
            className={styles.contactCloseButton}
          />
          <Form className={styles.contactForm}>
            <h2 className={styles.header}>צור קשר</h2>
            <div className={styles.text}> אנא השאר הודעה ונחזור אליך בהקדם ליצירת
              קשר
            </div>
            <div className={styles.contactName}>
              <FieldInput
                fieldId="fullName"
                value={values.fullName}
                label="שם"
                classNames={{
                  label: styles.label,
                  input: classnames(styles.input, styles.textarea)
                }}
              />
            </div>
            <div className={styles.contactEmail}>
              <FieldInput
                fieldId="email"
                type={'email'}
                value={values.email}
                label="כתובת אימייל"
                classNames={{
                  label: styles.label,
                  input: styles.input
                }}
              />
            </div>
            <div className={styles.contactMessage}>
              <FieldTextarea
                fieldId="message"
                value={values.message}
                label="הודעה"
                containerCustomStyles={styles.customTextarea}
                classNames={{
                  label: styles.label,
                  input: styles.input
                }}
              />
            </div>
            <button
              type="submit"
              className={styles.submitButton}
              disabled={!(values.fullName && values.message && values.email)}
              onClick={onSubmitClick}
            >
              שלח הודעה
            </button>
          </Form>
        </div>
        </div>
    </div>
  );
};

ContactLoginView.propTypes = {
  values: PropTypes.object
};

export default ContactLoginView;



